import styles from './styles'
import PropTypes from 'prop-types'
import OptionalText from '../OptionalText'
import { FormLabel, FormErrorMessage } from '@offerzen/pinata'
import { useRef, useEffect } from 'react'
import 'intl-tel-input/build/css/intlTelInput.css'
import intlTelInput from 'intl-tel-input'
import utils from 'intl-tel-input/build/js/utils'

const PhoneNumber = ({ label, htmlFor, labelClassName, optionalText, inputClassName, id, onChange, error }) => {
  // Setup phone number field
  const phoneNumberField = useRef()
  let iti

  useEffect(() => {
    iti = intlTelInput(phoneNumberField.current, {
      utilsScript: utils,
      customContainer: styles.phoneNumberWrapper,
      initialCountry: 'za',
      preferredCountries: ['za', 'nl', 'gb'],
    })
  }, [phoneNumberField, iti])

  return (
    <>
      <FormLabel label={label} className={labelClassName} htmlFor={htmlFor} />
      {optionalText && <OptionalText> ({optionalText})</OptionalText>}
      <input
        ref={phoneNumberField}
        id={id}
        className={`${styles.phoneNumberField} ${inputClassName || ''}`}
        onChange={() =>
          onChange({
            valid: iti.isValidNumber(),
            number: iti.getNumber(),
          })
        }
      />
      {error && <FormErrorMessage text={'Please fill in a valid phone number'} />}
    </>
  )
}

PhoneNumber.propTypes = {
  label: PropTypes.string,
  htmlFor: PropTypes.string,
  labelClassName: PropTypes.string,
  optionalText: PropTypes.string,
  inputClassName: PropTypes.string,
  id: PropTypes.string,
}

export default PhoneNumber
